import { FC } from 'react';
import { Grid } from '@mui/material';
import QuestTitle from '../QuestTitle';
import { QuestSchema } from 'src/types/quests';
import WorkOverview from '../WorkOverview';

interface Props {
    quest: QuestSchema;
}

const Header: FC<Props> = ({ quest }) => (
    <Grid container spacing={3} alignItems="center">
        <Grid item xs={12} sm={12} md={12} lg={6}>
            <QuestTitle quest={quest} />
        </Grid>
        <Grid item xs={0} sm={0} md={5} lg={5} />
        <Grid item xs={12} sm={12} md={4} lg={4}>
            <WorkOverview quest={quest} />
        </Grid>
    </Grid>
);

export default Header;
